import Glide from '@glidejs/glide';

export const storiesSlider = (e) => {
  const storiesSliderSelector = '.storiesSlider';
  if (typeof document.querySelector(storiesSliderSelector) !== 'undefined' && document.querySelector(storiesSliderSelector) !== null) {
    const sliderEl = document.querySelector('.storiesSlider');
    const isInViewport = (element) => {
      let scrollTop = (window.pageYOffset || document.scrollTop) - (document.clientTop || 0);
      let windowHeight = window.innerHeight || document.documentElement.clientHeight;
      scrollTop += windowHeight / 2;
      return scrollTop >= element.offsetTop && scrollTop <= element.offsetTop + element.offsetHeight;
    };
    const configuration = {
      type: 'carousel',
      perView: 1,
      focusAt: 'center',
      autoplay: 5000,
    };
    const glide = new Glide(storiesSliderSelector, configuration).mount();
    const slideItemsCount = document.querySelectorAll(storiesSliderSelector + ' .glide__slide:not(.glide__slide--clone)').length;

    for (let i = 0; i < slideItemsCount - 1; i++) {
      const node = document.querySelector('.glide_stories_nav div');
      const clone = node.cloneNode(true);
      document.querySelector('.glide_stories_nav').appendChild(clone);
    }
    const sliderNavs = Array.from(document.querySelectorAll('.glide_stories_nav > div'));
    if (sliderNavs != null && sliderNavs != undefined) {
      glide.on('run', function () {
        for (let i = 0; i < glide.index; i++) {
          sliderNavs[i].classList.add('bg-chubblue');
          sliderNavs[i].classList.remove('bg-chubstories');
          sliderNavs[i].classList.remove('animate');
        }
        if (sliderNavs[glide.index] != null && sliderNavs[glide.index] != undefined) {
          sliderNavs[glide.index].classList.add('animate');
          sliderNavs[glide.index].classList.remove('bg-chubblue');
          sliderNavs[glide.index].classList.add('bg-chubstories');
        }
        for (let i = glide.index + 1; i < slideItemsCount; i++) {
          sliderNavs[i].classList.remove('bg-chubblue');
          sliderNavs[i].classList.remove('animate');
          sliderNavs[i].classList.add('bg-chubstories');
        }
      });
    }

    glide.pause();
    let isAutoplayEnabled = false;
    document.addEventListener('scroll', (e) => {
      if (isAutoplayEnabled == false && isInViewport(sliderEl)) {
        glide.play();
        sliderNavs[0].classList.add('animate');
        isAutoplayEnabled = true;
      }
    });
  }
};

export const lifeSlider = (e) => {
  function GlideAutoHeight(Glide, Components, Events) {
    const Component = {
      mount() {
        if (!Glide.settings.autoHeight) return;
        Components.Html.track.style.transition = 'height 200ms ease-in-out';
        alert('test');
        this.updateTrackHeight();
      },

      updateTrackHeight() {
        if (!Glide.settings.autoHeight) return;

        const activeSlides = Components.Html.slides.filter((slide, index) => {
          return index >= Glide.index && index <= Glide.index - 1 + Glide.settings.perView;
        });

        const newMaxHeight = activeSlides.reduce((maxHeight, slide) => {
          return Math.max(maxHeight, slide.querySelector('.bg-white').offsetHeight);
        }, 0);

        const glideTrack = Components.Html.track;
        glideTrack.style.height = newMaxHeight + 'px';
      },
    };

    Events.on('run', () => {
      Component.updateTrackHeight();
    });
    Events.on('update', () => {
      Component.updateTrackHeight();
    });
    Events.on('resize', () => {
      Component.updateTrackHeight();
    });

    return Component;
  }
  var glideHandleHeight = function glideHandleHeight() {
    var activeSlide = document.querySelector('.glide__slide--active');
    var activeSlideHeight = activeSlide ? activeSlide.offsetHeight : 0;
    var glideTrack = document.querySelector('.glide__track');
    var glideTrackHeight = glideTrack ? glideTrack.offsetHeight : 0;

    if (activeSlideHeight !== glideTrackHeight) {
      glideTrack.style.height = ''.concat(activeSlideHeight, 'px');
    }
  };
  const lifeSliderSelector = '.lifeSlider';
  if (typeof document.querySelector(lifeSliderSelector) !== 'undefined' && document.querySelector(lifeSliderSelector) !== null) {
    const configuration = {
      type: 'carousel',
      perView: 1,
      focusAt: 'center',
      autoplay: false,
    };
    const lifeGlide = new Glide(lifeSliderSelector, configuration);
    // lifeGlide.on('swipe.start', () => {
    //   glideHandleHeight();
    // });
    // lifeGlide.on('build.after', () => {
    //   glideHandleHeight();
    // });
    lifeGlide.on('build.after', function () {
      var slideHeight = document.querySelector('.lifeSlider .glide__slide--active').getBoundingClientRect().height;
      var glideTrack = document.querySelector('.lifeSlider .glide__track').getBoundingClientRect().height;
      if (slideHeight != glideTrack) {
        var newHeight = slideHeight;
        document.querySelector('.lifeSlider .glide__track').style.height = newHeight + 'px';
      }
    });

    lifeGlide.on('run.after', function () {
      var slideHeight = document.querySelector('.lifeSlider .glide__slide--active').getBoundingClientRect().height;
      var glideTrack = document.querySelector('.lifeSlider .glide__track').getBoundingClientRect().height;
      if (slideHeight != glideTrack) {
        var newHeight = slideHeight;
        document.querySelector('.lifeSlider .glide__track').style.height = newHeight + 'px';
      }
    });
    lifeGlide.mount({
      GlideAutoHeight: GlideAutoHeight,
    });
  }
};

//testimonial-slider
export const testimonialSlider = (e) => {
  const testimonialSliderSelector = '.testimonialSlider';
  if (typeof document.querySelector(testimonialSliderSelector) !== 'undefined' && document.querySelector(testimonialSliderSelector) !== null) {
    const configuration = {
      type: 'carousel',
      perView: 1,
      focusAt: 'center',
      animationDuration: 1000,
      autoplay: false,
    };
    new Glide(testimonialSliderSelector, configuration).mount();
  }
};

//case slider
export const caseSlider = (e) => {
  const caseSliderSelector = '.caseslider';
  function GlideAutoHeight(Glide, Components, Events) {
    const Component = {
      mount() {
        if (!Glide.settings.autoHeight) return;
        Components.Html.track.style.transition = 'height 200ms ease-in-out';
        alert('test');
        this.updateTrackHeight();
      },

      updateTrackHeight() {
        if (!Glide.settings.autoHeight) return;

        const activeSlides = Components.Html.slides.filter((slide, index) => {
          return index >= Glide.index && index <= Glide.index - 1 + Glide.settings.perView;
        });

        const newMaxHeight = activeSlides.reduce((maxHeight, slide) => {
          return Math.max(maxHeight, slide.querySelector('.bg-white').offsetHeight);
        }, 0);

        const glideTrack = Components.Html.track;
        glideTrack.style.height = newMaxHeight + 'px';
      },
    };

    Events.on('run', () => {
      Component.updateTrackHeight();
    });
    Events.on('update', () => {
      Component.updateTrackHeight();
    });
    Events.on('resize', () => {
      Component.updateTrackHeight();
    });

    return Component;
  }

  if (typeof document.querySelector(caseSliderSelector) !== 'undefined' && document.querySelector(caseSliderSelector) !== null) {
    const configuration = {
      type: 'slider',
      perView: 1,
      focusAt: 'center',
      animationDuration: 1000,
      autoplay: false,
    };
    let caseSliderGlide = new Glide(caseSliderSelector, configuration).mount();
    caseSliderGlide.on('build.after', function () {
      var slideHeight = document.querySelector('.caseslider .glide__slide--active').getBoundingClientRect().height;
      var glideTrack = document.querySelector('.caseslider .glide__track').getBoundingClientRect().height;
      if (slideHeight != glideTrack) {
        var newHeight = slideHeight;
        document.querySelector('.caseslider .glide__track').style.height = newHeight + 'px';
      }
    });

    caseSliderGlide.on('run.after', function () {
      var slideHeight = document.querySelector('.caseslider .glide__slide--active').getBoundingClientRect().height;
      var glideTrack = document.querySelector('.caseslider .glide__track').getBoundingClientRect().height;
      if (slideHeight != glideTrack) {
        var newHeight = slideHeight;
        document.querySelector('.caseslider .glide__track').style.height = newHeight + 'px';
      }
    });
    caseSliderGlide.mount({
      GlideAutoHeight: GlideAutoHeight,
    });
  }
};



// Clients slider

const clientsSlider = '.clientsSlider';
if (typeof document.querySelector(clientsSlider) !== 'undefined' && document.querySelector(clientsSlider) !== null) {
  const slidesCount = document.querySelector(clientsSlider).getAttribute('data-count');
  new Glide(clientsSlider, {
    perView: slidesCount == 1 ? 1 : (slidesCount == 2 ? 2 : 3),
    type: 'carousel',
    gap: 40,
    hoverpause: true,
    breakpoints: {
      1400: {
        perView: slidesCount == 1 ? 1 : 2,
      },
      700: {
        perView: 1,
      },
    },
  }).mount();
  if(slidesCount == 1 || slidesCount == 2) {
    const clientsSliderEl = document.querySelector(clientsSlider);
    let isArrowsHidden = false;
    const hideShowArrows = () => {
      if (isArrowsHidden && window.innerWidth <= 700 && slidesCount != 1) {
        clientsSliderEl.querySelector('.glide__arrows').style.display = 'block';
        clientsSliderEl.querySelector('.glide__bullets').style.display = 'block';
        isArrowsHidden = false;
      }
      if(!isArrowsHidden && window.innerWidth > 700) {
        clientsSliderEl.querySelector('.glide__arrows').style.display = 'none';
        clientsSliderEl.querySelector('.glide__bullets').style.display = 'none';
        isArrowsHidden = true;
      }
    }
    window.addEventListener('resize', hideShowArrows);
    hideShowArrows();
  }
}

//home-page - promises slider
const promisesSlider = '.promisesSlider';
if (typeof document.querySelector(promisesSlider) !== 'undefined' && document.querySelector(promisesSlider) !== null) {
  new Glide(promisesSlider, {
    perView: 1,
    type: 'carousel',
    hoverpause: true,
    autoplay: 3000,
  }).mount();
}
